import { styled } from '@mui/material'

const Image = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}))

export default Image
